export default [
	'Anchored',
	'Anchored - Grocery',
	'Mall',
	'Mix-Use',
	'Neighborhood Center',
	'Power Center',
	'Retail Strip',
	'Shadow Anchored',
];